import React, { Fragment, useEffect, useState } from 'react';
import { WebinarDate, WebinarPlate, WebinarTitle } from '../MainPageStyled';
import { Space } from '@gr-monorepo/common/ui';
import { WebinarsApi } from 'api';
import { Api } from 'api/cabmun-content-public';
import { PlateTemplate } from './PlateTemplate';
import useUserData from 'hooks/useUserData';
import dayjs from 'dayjs';
import ruWithMonth from 'utils/dayjs/ruWithMonth';
import LoaderComponent from 'features/shared/Loader';
import { Error } from './Error';
const now = new Date();

const Item = (props: { data: Api.GetWebinars200Response }) => {
  const startDate = props.data.startDate ? new Date().setDateWithoutTimezone(props.data.startDate) : '';
  const endDate = props.data.endDate ? new Date().setDateWithoutTimezone(props.data.endDate) : '';
  const date = `${dayjs(startDate).locale('ru_with_month', ruWithMonth).format('DD MMMM')}・${dayjs(startDate).format(
    'HH:mm',
  )}${endDate ? `-${dayjs(endDate).format('HH:mm')}` : ''} мск`;
  return (
    <WebinarPlate>
      <WebinarDate>{date}</WebinarDate>
      <WebinarTitle>{props.data.name}</WebinarTitle>
    </WebinarPlate>
  );
};

export const Webinars = () => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  const [webinars, setWebinars] = useState<Api.GetWebinars200Response[]>();
  const userData = useUserData();
  useEffect(() => {
    if (!userData?.id) return;
    async function fetch() {
      setPending(true);
      try {
        const result = await WebinarsApi.getWebinars(userData!.id!);
        const prepareResult = result
          .filter((el) => el.startDate)
          .map((el) => ({ ...el, time: new Date(el.startDate!).getTime() }));
        prepareResult.sort((a, b) => a.time - b.time);
        const orderWebinars = [
          ...prepareResult.filter((el) => el.time >= now.getTime()),
          ...prepareResult.filter((el) => el.time < now.getTime()),
        ];

        setWebinars(orderWebinars.slice(0, 3));
      } catch (e) {
        setError(true);
      }
      setPending(false);
    }

    fetch();
  }, [userData?.id]);
  if (pending) {
    return (
      <PlateTemplate title="Вебинары для учителей" link="/webinars" name="webinars" dataQaId="webinars_block">
        <LoaderComponent color={'#825AF7'} />{' '}
      </PlateTemplate>
    );
  }
  if (error) {
    return (
      <PlateTemplate title="Вебинары для учителей" link="/webinars" name="webinars" dataQaId="webinars_block">
        <Error />
      </PlateTemplate>
    );
  }
  return (
    <PlateTemplate title="Вебинары для учителей" link="/webinars" name="webinars" dataQaId="webinars_block">
      <Space size={24} axis="vertical" />
      {webinars?.length === 0 && <>Нет ближайших запланированных вебинаров</>}
      {webinars?.map((el) => (
        <Fragment key={el.id}>
          <Item data={el} />
          <Space size={24} axis="vertical" />
        </Fragment>
      ))}
    </PlateTemplate>
  );
};
